<template>
  <div>
    <van-action-sheet
      v-model="show"
      title="确认支付信息"
      @cancel="onCancel"
      class="payment-sheet"
    >
      <div class="contentPay" v-if="resultList.length > 0">
        <div v-if="yhShow === false">
          <!-- 项目信息卡片 -->
          <div class="info-card">
            <div class="card-header">
              <van-icon name="orders-o" class="header-icon" />
              <span class="header-title">项目信息</span>
            </div>
            <van-cell title="组别" :value="resultList[0].XMJC" />
            <van-cell
              title="项目"
              v-if="
                ssid !==
                  '69736c3638616f7575746b79664f736b334f425763314a66314841587771497a'
              "
              :value="resultList[0].SSLXMC"
            />
            <van-cell
              title="项目"
              v-if="
                ssid ===
                  '69736c3638616f7575746b79664f736b334f425763314a66314841587771497a'
              "
              :value="resultList[0].SSLXMC.substr(0, 1) + '子'"
            />
          </div>

          <!-- 运动员信息卡片 -->
          <div class="info-card">
            <div class="card-header">
              <van-icon name="friends-o" class="header-icon" />
              <span class="header-title">运动员信息</span>
            </div>
            <van-cell
              v-for="(item, index) in resultList"
              :key="index"
              title="运动员"
              :value="
                item.RYXM1 + (item.RYXM2.length > 0 ? '/' + item.RYXM2 : '')
              "
              :label="
                item.YHEXISTS === '1'
                  ? item.ISYHSH === '1'
                    ? '您的优惠申请已审核'
                    : '您申请的优惠未审核，请等待主办方审核'
                  : ''
              "
            />
          </div>

          <!-- 费用信息卡片 -->
          <div>
            <div class="card-header">
              <van-icon name="gold-coin-o" class="header-icon" />
              <span class="header-title">费用明细</span>
            </div>
            <div v-if="resultList[0].ISDTSFBZ !== '1'">
              <van-cell
                title="优惠总金额"
                :value="YHZJE + '元'"
                v-if="resultList[0].ISHYMF === '1'"
                class="discount-cell"
              />
            </div>
            <van-cell
              title="支付金额"
              :value="SJZJE + '元'"
              v-if="TEAMYHJE - 0 > 0 && SJZJE > 0"
            />
            <van-cell
              title="团队报名优惠"
              :value="TEAMYHJE + '元'"
              v-if="TEAMYHJE - 0 > 0 && SJZJE > 0"
              class="discount-cell"
            />
            <van-cell
              title="兼项优惠"
              :value="JXYHJE + '元'"
              v-if="JXYHJE - 0 > 0 && SJZJE > 0"
              class="discount-cell"
            />
            <!-- <van-cell
              title="兼项优惠说明"
              :value="JXYHMSG"
              v-if="JXYHJE - 0 > 0 && SJZJE > 0"
              class="discount-note"
            /> -->
            <div
              v-if="JXYHJE - 0 > 0 && SJZJE > 0"
              style="background: #fff;padding-left: 17px;padding-right: 15px;"
            >
              <div
                style="color: #7b7b7b;font-size: 15px;padding-top: 11px;padding-bottom: 11px;"
              >
                兼项优惠说明
              </div>
              <div
                v-html="JXYHMSG"
                style="color: #7b7b7b;font-size: 15px;padding-bottom: 11px;"
              ></div>
            </div>
            <div v-if="SJZJE > 0" class="total-amount">
              <span class="total-label">支付总金额</span>
              <span class="total-value">{{ getFinZfje(resultList[0]) }}</span>
            </div>

            <!-- 收费标准选择 -->
            <div v-if="resultList[0].ISDTSFBZ === '1'" class="fee-standard">
              <div class="standard-header">
                <van-icon name="label-o" class="standard-icon" />
                <span class="standard-title">请选择收费标准</span>
              </div>
              <div class="standard-options">
                <div
                  @click="checkSkuHandler(dtItem, resultList[0].DTSFBZ)"
                  v-for="(dtItem, dtIndex) in resultList[0].DTSFBZ"
                  :key="dtIndex"
                  class="standard-option"
                  :class="{ active: active === dtItem.BZID }"
                >
                  {{ dtItem.SFBZMC }}
                </div>
              </div>
              <div v-if="sfms" class="standard-note">
                <van-icon name="info-o" />
                {{ sfms }}
              </div>
            </div>
          </div>
        </div>

        <!-- 会员优惠申请 -->
        <van-cell-group v-if="yhShow" class="member-group">
          <div class="card-header">
            <van-icon name="vip-card-o" class="header-icon" />
            <span class="header-title">会员优惠申请</span>
          </div>
          <div v-for="(item, index) in resultList" :key="index">
            <van-field
              v-model="item.HYZCM1"
              :label="item.RYXM1 + '会员码'"
              placeholder="请输入会员码"
              :error-message="
                item.ISDTSFBZ === '1' ? '' : '会员可优惠' + item.KYHJE + '元'
              "
            />
            <van-field
              v-if="
                item.RYXM2 !== undefined &&
                  item.SFZH2 !== '-' &&
                  item.RYXM2.length > 0
              "
              v-model="item.HYZCM2"
              :label="item.RYXM2 + '会员码'"
              placeholder="请输入会员码"
              :error-message="
                item.ISDTSFBZ === '1' ? '' : '会员可优惠' + item.KYHJE + '元'
              "
            />
          </div>
        </van-cell-group>

        <div style="width:15px;height:80px"></div>

        <!-- 底部操作按钮 -->
        <van-goods-action
          v-if="resultList[0].ISYHSH === '1'"
          class="payment-actions"
        >
          <van-goods-action-button
            type="warning"
            text="申请优惠"
            @click="sqyhHandler"
            v-if="yhShow === false && ISHYMF === '1'"
            class="action-btn"
          />
          <van-goods-action-button
            type="danger"
            text="取消申请"
            v-if="yhShow && ISHYMF === '1'"
            @click="cancelYhSqHandler"
            class="action-btn"
          />
          <van-goods-action-button
            type="primary"
            text="发起申请"
            v-if="yhShow && ISHYMF === '1'"
            @click="fqYhSqHandler"
            class="action-btn"
          />
          <van-goods-action-button
            type="primary"
            text="发起支付"
            v-if="yhShow === false"
            @click="sendPayHandler"
            class="action-btn pay-btn"
          />
        </van-goods-action>
      </div>
    </van-action-sheet>

    <loading-com></loading-com>
  </div>
</template>

<script>
import { Dialog } from "vant";
import LoadingCom from "./LoadingCom.vue";
export default {
  name: "EnterPayCom",
  components: { LoadingCom },
  data() {
    return {
      show: false,
      yhShow: false,
      reqDatas: {},
      utilPost: "",
      op: "payGl",
      ssid: "",
      resultList: [],
      ZFZJE: 0,
      YHZJE: 0,
      SJZJE: 0,
      ISHYMF: "",
      sfms: "",
      active: "",
      TEAMYHJE: 0,
      JXYHJE: 0,
      JXYHMSG: ""
    };
  },
  mounted() {
    this.utilPost = this.$util.handler;
    this.active = "";
    this.sfms = "";
  },
  methods: {
    getFinZfje(item) {
      return item.ISDTSFBZ !== "1"
        ? parseFloat(this.ZFZJE - this.TEAMYHJE - 0 - this.JXYHJE - 0).toFixed(
            2
          )
        : (this.active.length === 0
            ? 0
            : parseFloat(
                this.ZFZJE - this.TEAMYHJE - 0 - this.JXYHJE - 0
              ).toFixed(2)) + "元";
    },
    checkSkuHandler(dtSfbzItem, dtSfbzList) {
      this.SJZJE = dtSfbzItem.SFBZ;
      this.ZFZJE = dtSfbzItem.SFBZ;
      this.sfms = dtSfbzItem.SFMS;
      this.active = dtSfbzItem.BZID;
      for (var i = 0; i < dtSfbzList.length; i++) {
        dtSfbzList[i].ISXZ = "0";
      }
      for (var i = 0; i < dtSfbzList.length; i++) {
        if (dtSfbzItem.BZID === dtSfbzList[i].BZID) {
          dtSfbzList[i].ISXZ = "1";
        }
      }
    },
    mainLoadData: function() {
      var busData = this.reqDatas;
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "mainLoadData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        this.resultList = data.content.CONTENT;
        this.ZFZJE = data.content.ZFZJE;
        this.YHZJE = data.content.YHZJE;
        this.SJZJE = data.content.SJZJE;
        this.TEAMYHJE = data.content.TEAMYHJE;
        this.JXYHJE = data.content.JXYHJE;
        this.JXYHMSG = data.content.JXYHMSG;
        if (data.content.ISZF === "1") {
          this.show = false;
        }
      });
    },
    setXmnmArray: function(datas, ssid) {
      this.active = "";
      this.sfms = "";
      this.reqDatas = datas;
      this.ssid = ssid;
      this.mainLoadData();
    },
    openPayModal: function() {
      var busData = this.reqDatas;
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "mainLoadData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.content.ISZF !== "1") {
          this.show = true;
          this.ISHYMF = data.content.CONTENT[0].ISHYMF;
        } else {
          this.$notify({
            type: "success",
            message: "您已支付完成",
            duration: 2000
          });
        }
      });
    },
    onCancel: function() {
      this.show = false;
      // this.$emit("child-event");
      // this.$emit("update:isPay", false);
    },
    sqyhHandler: function() {
      if (this.resultList.length > 0) {
        if (this.resultList[0].ISDTSFBZ === "1") {
          if (this.active.length === 0) {
            this.$notify({
              type: "danger",
              message: "请选择标准",
              duration: 2000
            });
            return;
          }
        }
      }
      this.yhShow = true;
    },
    cancelYhSqHandler: function() {
      this.yhShow = false;
    },
    //发起优惠申请
    fqYhSqHandler: function() {
      Dialog.confirm({
        title: "提示",
        message: "是否提交申请？"
      })
        .then(() => {
          var busData = {
            XMNMS: this.resultList,
            BZID: this.active
          };
          var paramData = {
            headerData: {
              ssid: this.ssid,
              op: this.op, //反射名称
              methodName: "sqYh" //对应的方法名
            },
            busData: busData //参数内容
          };
          this.utilPost.paramData = paramData;
          this.utilPost.sendPost().then(data => {
            this.$notify({
              type: data.isSuccess ? "success" : "danger",
              message: data.msg,
              duration: 6000
            });
            if (data.isSuccess) {
              this.yhShow = false;
              this.mainLoadData();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    sendPayHandler: function() {
      var numIsxz = 0;
      var xzBzid = "";
      var ISDTSFBZ = false;
      for (var i = 0; i < this.resultList.length; i++) {
        ISDTSFBZ = this.resultList[i].ISDTSFBZ;
        for (var j = 0; j < this.resultList[i].DTSFBZ.length; j++) {
          var DTSFBZ = this.resultList[i].DTSFBZ[j];
          var ISXZ = DTSFBZ.ISXZ;
          var BZID = DTSFBZ.BZID;
          if (ISXZ === "1") {
            numIsxz++;
            xzBzid = BZID;
          }
        }
      }

      if (ISDTSFBZ === "1") {
        if (this.active === "" || this.active.length === 0) {
          this.$notify({
            type: "danger",
            message: "请选择收费标准",
            duration: 6000
          });
          return;
        }
        if (numIsxz != 1) {
          this.$notify({
            type: "danger",
            message: "收费标准不唯一",
            duration: 6000
          });
          return;
        }
        if (xzBzid !== this.active) {
          this.$notify({
            type: "danger",
            message: "收费标准不符和要求",
            duration: 6000
          });
          return;
        }
      }
      var busData = {
        XMNMS: this.resultList
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "paymentYhddh" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          this.$notify({
            type: data.isSuccess ? "success" : "danger",
            message: data.msg,
            duration: 6000
          });
          return;
        }
        this.show = false;
        // alert(JSON.stringify(data));
        if (data.code === "SUCCESS") {
          this.$notify({
            type: "success",
            message: "处理成功",
            duration: 6000
          });

          if (
            this.ssid ===
            "79316c74486b73572f6e463753376b686444774c4479565045504933436f2b79"
          ) {
            // 2秒后执行  2000毫秒
            window.document.getElementById("LoadingComId").style.display =
              "block";
            setTimeout(() => {
              window.document.getElementById("LoadingComId").style.display =
                "none";
              this.$emit("child-event");
              this.$emit("update:isPay", false);
              this.$emit("update:czlx", "");
            }, 1200);
          } else {
            this.$emit("child-event");
            this.$emit("update:isPay", false);
            this.$emit("update:czlx", "");
          }
        } else {
          this.$emit("update:isPay", false);
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.jsApiCall,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", this.jsApiCall);
              document.attachEvent("onWeixinJSBridgeReady", this.jsApiCall);
            }
          } else {
            window.document.getElementById("LoadingComId").style.display =
              "block";
            setTimeout(() => {
              this.jsApiCall(data.content.param, data.content.notifyUrl);
              window.document.getElementById("LoadingComId").style.display =
                "none";
            }, 300);
          }
        }
      });
    },
    jsApiCall(paramJsonStr, notifyUrl) {
      WeixinJSBridge.invoke("getBrandWCPayRequest", paramJsonStr, function(
        res
      ) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          alert("支付成功！");
          window.location.href = notifyUrl;
        } else {
          alert("支付失败!请核实订单或重新支付。");
          window.location.href = window.location.href;
        }
      });
    }
  }
};
</script>
<style scoped>
/* 字体渲染优化 */
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

.contentPay {
  padding: 1rem;
  padding-bottom: 5rem;
  background: #f5f6fa;
}

/* 信息卡片 */
.info-card {
  background: #fff;
  border-radius: 0.875rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 2px solid #e9ecef;
}

.header-icon {
  font-size: 1.25rem;
  color: #185f9b;
}

.header-title {
  font-size: 1rem;
  font-weight: 700;
  color: #333;
}

/* 费用卡片特殊样式 */
.fee-card {
  border: 2px solid #185f9b;
}

.fee-card .card-header {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border-bottom: none;
}

.fee-card .header-icon,
.fee-card .header-title {
  color: #fff;
}

/* 优惠单元格 */
.discount-cell /deep/ .van-cell__value {
  color: #10b981;
  font-weight: 600;
}

.discount-note /deep/ .van-cell__value {
  color: #6b7280;
  font-size: 0.8125rem;
}

/* 总金额 */
.total-amount {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1rem;
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  border-top: 2px dashed #fb923c;
  margin-top: 0.5rem;
}

.total-label {
  font-size: 1.125rem;
  font-weight: 700;
  color: #9a3412;
}

.total-value {
  font-size: 1.5rem;
  font-weight: 800;
  color: #dc2626;
}

/* 收费标准选择 */
.fee-standard {
  padding: 1rem;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}

.standard-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.standard-icon {
  font-size: 1.125rem;
  color: #185f9b;
}

.standard-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #374151;
}

.standard-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.standard-option {
  padding: 0.625rem 1.25rem;
  background: #e5e7eb;
  color: #6b7280;
  font-size: 0.9375rem;
  font-weight: 600;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.standard-option.active {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  border-color: #185f9b;
  box-shadow: 0 4px 12px rgba(24, 95, 155, 0.3);
  transform: translateY(-2px);
}

.standard-note {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #fef2f2;
  border-left: 3px solid #dc2626;
  border-radius: 0.375rem;
  color: #991b1b;
  font-size: 0.8125rem;
  line-height: 1.5;
}

/* 会员组 */
.member-group {
  background: #fff;
  border-radius: 0.875rem;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 1rem;
}

.member-group .card-header {
  padding: 1rem;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border-bottom: 2px solid #fbbf24;
}

.member-group .header-icon {
  color: #92400e;
}

.member-group .header-title {
  color: #92400e;
}

/* 底部间距 */

/* 底部操作按钮 */
.payment-actions {
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
}

.action-btn {
  font-weight: 600;
  font-size: 0.9rem;
}

.pay-btn {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}

/* 弹出层样式 */
.payment-sheet /deep/ .van-action-sheet__header {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  font-weight: 700;
  font-size: 1.125rem;
}

/* 单元格样式优化 */
/deep/ .van-cell {
  padding: 0.875rem 1rem;
}

/deep/ .van-cell__title {
  color: #6b7280;
  font-weight: 500;
}

/deep/ .van-cell__value {
  color: #1f2937;
  font-weight: 600;
}

/deep/ .van-cell__label {
  color: #10b981;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/EnterPayCom.vue